import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button} from "react-bootstrap";
import AsideMain from "./AsideMain";
import config from "../../config";

// import img2 from '../../assets/temp/news2.png';
import {fetchAnswers, fetchQuestions, getNewsList, getThematicList} from "../../store/actions/main";
import {parseQuery} from "../../lib";
import {fetchAsideCategories} from "../../store/actions/asideCategories";
import {fetchBestPractices} from "../../store/actions/bestPractices";
import LoginModal from "../../components/UI/Modals/LoginModal";
import {fetchCurrentUser} from "../../store/actions/users";
import {login} from "../../store/actions/auth";
import Preloader from "../../components/UI/Preloader/Preloader";
// import IMask from "imask";
// import {Link} from "react-router-dom";
// import OneNewsInfo from "./OneNewsInfo";
// import {Route} from "react-router";

class Main extends Component {
  state = {
    radio: '',
    language: this.props.language,
    checked: [],
    loginModal: false,
    email: '',
    password: '',
    loginModalMessage: '',
    loginErrorMessage: ''
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.language !== prevState.language) {
      nextProps.onGetThematicList(parseQuery({lang: nextProps.language}));
      nextProps.onGetNewsList(parseQuery({lang: nextProps.language}));
      return {
        language: nextProps.language
      }
    }
    return null;
  }

  async componentDidMount() {
    this.props.onGetThematicList(parseQuery({lang: this.props.language}));
    this.props.onGetNewsList(parseQuery({lang: this.props.language}));
    this.props.onFetchQuestions(parseQuery({lang: this.props.language, status: 1}));
    await this.props.onFetchBestPractices(parseQuery({lang: this.props.language, practice_vote: 1, status: 1}));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.questions.length && this.props.questions !== prevProps.questions) {
      this.props.onFetchAnswers(parseQuery({lang: this.props.language, polls_id: this.props.questions[0].id}));
    }
  }

  toggleLoginModal = () => {
    this.setState(prevProps => {
      return {loginModal: !prevProps.loginModal}
    });
  };

  onCloseLoginModal = () => {
    this.setState({loginModal: false, email: '', password: '', loginModalMessage: ''})
  };

  onChangeHandler = event => {
    // if (event.target.value.match(/\d+/g) !== null && event.target.name === 'email') {
    //   let element = document.getElementById('emailmain');
    //   let maskOptions = {
    //     mask: '+{996}(000)00-00-00'
    //   }
    //   let mask = IMask(element, maskOptions);
    //   this.setState({[event.target.name]: mask._value});
    //   mask.destroy();
    // } else
      this.setState({[event.target.name]: event.target.value});
  };

  onSubmitHandler = async event => {
    const {t} = this.props;
    event.preventDefault();
    let email;

    if (this.state.email.includes('+996(')) {
      email = this.state.email
        .replace('(', '')
        .replace(')', '')
        .replace('-', '')
        .replace('-', '');
    } else email = this.state.email
    let data = {
      email: email,
      password: this.state.password
    };

    await this.props.onLogin(data);

    if (this.props.loginError !== null) {
      this.setState({loginErrorMessage: t("header.loginError")})
    } else {
      this.props.onFetchCurrentUser();
      this.setState({loginErrorMessage: ''})
      this.onCloseLoginModal();
      this.props.redirectOn('Main', parseQuery({lang: this.props.language}));
    }
  };

  handleOnCheck = (e, id) => {
    let checked = [...this.state.checked];
    if (checked.includes(id)) checked.splice(checked.findIndex(item => item === id), 1);
    else checked.push(id);

    this.setState({checked})
  };

  handleRadio = (e, item) => {
    this.setState({radio: item.title})
  };

  handleRedirect = async (id) => {
    await this.props.onFetchAsideCategories(parseQuery({lang: this.props.language, thematics_id: id}));
    if (this.props.asideCategories.length) {
      // this.props.redirectOn('NPA', parseQuery({thematics_id: id, category_id: this.props.asideCategories[0].id}))
      this.props.redirectOn('Best practices list', parseQuery({lang: this.props.language, thematics_id: id, category_id: this.props.asideCategories[0].id}))
    }
  };

  handleSaveAnswer = () => {
    const {t} = this.props;
    if (!Object.keys(this.props.currentUser).length) {
      this.setState({loginModalMessage: t("loginModal.saveTheAnswer")});
      this.toggleLoginModal();
    }
  };

  handleRedirectToNews = (id) => {
    this.props.redirectOn('Single news info', parseQuery({lang: this.props.language, id}))
  };

  handleRedirectToNewsArchive = event => {
    event.preventDefault();
    this.props.redirectOn('News archive', parseQuery({lang: this.props.language}))
  }

  render() {
    let question, answers, typeQuestionId;

    try {
      question = this.props.questions[0].question;
    } catch (e) {
      question = null;
    }

    try {
      typeQuestionId = this.props.questions[0].type_question_id;
    } catch (e) {
      typeQuestionId = null
    }

    try {
      answers = this.props.answers.map(el => {
        return (
          typeQuestionId === 2 ?
            <div className="survey-block__answer-item" key={el.id} onClick={e => this.handleOnCheck(e, el.id)}>
              <i id={el.id} className={`fa fa-${this.state.checked.includes(el.id) ? 'check-' : ''}square-o`}> </i>
              <span>{el.title}</span>
            </div> :
            <div className="survey-block__answer-item" key={el.id} onClick={(e) => this.handleRadio(e, el)}>
              <i className={`fa fa-${this.state.radio === el.title ? 'check-' : ''}circle-o`}> </i>
              <span>{el.title}</span>
            </div>
        )
      })
    } catch (e) {

    }

    const {t} = this.props;
    return (
      <div className="container page-wrapper">
        <div className="main">
          <div className="categories-block">
            {this.props.thematicLoading ? <div className="categories-block__main-preloader-wrapper"><Preloader/></div> : this.props.thematicList.map((cat, idx) => (
              <div className="categories-block__item"
                   key={'category' + idx}
                   onClick={() => this.handleRedirect(cat.id)}
              >
                <div className="categories-block__icon-wrapper">
                  <img src={cat.image ? `${config.apiUrl}/storage/${cat.image}` : " "} alt=""
                       onDragStart={e => e.preventDefault()}/>
                </div>
                <div className="categories-block__title">
                  {cat.title}
                </div>
              </div>
            ))}
          </div>

          <div className="news-block">
            <h3 className="news-block__head-line">
              {t('main.News')}
            </h3>
            <div className="news-block__list">
              {this.props.newsLoading ? <Preloader/> : this.props.newsList.map((el, idx) => (
                <div className="news-block__item" key={'news' + idx} onClick={() => this.handleRedirectToNews(el.id)}>
                  {el.image ?
                    <div className="news-block__img-wrapper">
                      <img src={el.image ? `${config.apiUrl}/storage/${el.image}` : null} alt=""/>
                    </div>
                    : null}
                  <div className="news-block__news-content">
                    {this.props.pageWidth > 830 ? <p className="news-block__date">
                      {el.created_at}
                    </p> : null}
                    <h4 className="news-block__title">
                      {el.title}
                    </h4>
                    {this.props.pageWidth <= 830 ? <p className="news-block__date">
                      {el.created_at}
                    </p> : null}
                    {this.props.pageWidth >= 830 ? <p className="news-block__description">
                      {el.short_description}
                    </p> : null}
                  </div>
                </div>
              )).slice(-10).reverse()}
            </div>
            <Button onClick={e => this.handleRedirectToNewsArchive(e)}>{t("main.newsArchive")}</Button>
          </div>

          <div className="survey-block">
            <h3 className="survey-block__head-line">
              {t('main.Take part in the survey')}
            </h3>
            <div className="survey-block__inner">
              <h4 className="survey-block__title">
                {/*{t('main.Do you like the new portal')}afs*/}
                {this.props.questionsLoading ? <Preloader/> : question}
              </h4>
              <div className="survey-block__answer-box">
                {answers}
              </div>
              <Button variant="success" onClick={this.handleSaveAnswer}>
                {t('main.Save answer')}
              </Button>
            </div>
          </div>
        </div>

        <AsideMain {...this.props}/>
        <LoginModal {...this.props}
                    asideCheck
                    loginModal={this.state.loginModal}
                    onClose={this.onCloseLoginModal}
                    onChange={e => this.onChangeHandler(e)}
                    onSubmit={e => this.onSubmitHandler(e)}
                    message={this.state.loginModalMessage}
                    error={this.state.loginErrorMessage}
                    id={'main'}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  language: state.auth.language,
  thematicList: state.main.thematicList,
  thematicLoading: state.main.thematicLoading,
  newsList: state.main.newsList,
  newsLoading: state.main.newsLoading,
  questions: state.main.questions,
  questionsLoading: state.main.questionsLoading,
  answers: state.main.answers,
  loading: state.main.loading,
  asideCategories: state.asideCategories.asideCategories,
  bestPractices: state.bestPractices.bestPractices,
  loginError: state.auth.loginError
});

const mapDispatchToProps = dispatch => ({
  onGetThematicList: query => dispatch(getThematicList(query)),
  onGetNewsList: query => dispatch(getNewsList(query)),
  onFetchQuestions: query => dispatch(fetchQuestions(query)),
  onFetchAnswers: query => dispatch(fetchAnswers(query)),
  onFetchAsideCategories: query => dispatch(fetchAsideCategories(query)),
  onFetchBestPractices: query => dispatch(fetchBestPractices(query)),
  onFetchCurrentUser: () => dispatch(fetchCurrentUser()),
  onLogin: data => dispatch(login(data)),

});


export default connect(mapStateToProps, mapDispatchToProps)(Main);
